import { useEffect, useState } from "react";

const VideoPlayer = (videoElement: any) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasBeenVisible, setHasBeenVisible] = useState(false);
  const [hasUserInteracted, setHasUserInteracted] = useState(false);

  const togglePlay = () => {
    setIsPlaying(!isPlaying);
    setHasUserInteracted(true);
  };

  // Effect to observe video visibility
  useEffect(() => {
    if (!videoElement.current) return;

    const element = videoElement.current;
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && !hasBeenVisible) {
          setIsPlaying(true);
          setHasBeenVisible(true);
        }
      },
      {
        threshold: 0.5, // Trigger when 50% of the video is visible
      }
    );

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  }, [videoElement, hasBeenVisible]);

  useEffect(() => {
    if (videoElement.current) {
      isPlaying ? videoElement.current.play() : videoElement.current.pause();
    }
  }, [isPlaying, videoElement]);

  return { togglePlay, isPlaying, hasUserInteracted };
};

export default VideoPlayer;
